// Centralized role & permission configuration
export const EXTERNAL_ROLES = ["buyer", "seller", "dealer", "inspector", "service_partner"];

export const INTERNAL_ROLES = [
  "concierge_staff", "marketplace_admin", "verification_admin",
  "certification_admin", "valuation_admin", "transaction_admin",
  "auction_admin", "support_admin", "finance_admin",
  "content_admin", "executive_admin", "super_admin",
];

export const SUPER_ADMIN_ROLES = ["super_admin", "admin"]; // "admin" legacy compat
export const LISTING_CAPABLE = ["seller", "dealer", ...INTERNAL_ROLES, "admin"];

export const ROLE_LABELS = {
  buyer: "Buyer", seller: "Private Seller", dealer: "Dealer",
  inspector: "Inspector", service_partner: "Service Partner",
  concierge_staff: "Concierge Staff", marketplace_admin: "Marketplace Administrator",
  verification_admin: "Verification Administrator", certification_admin: "Certification Administrator",
  valuation_admin: "Valuation Administrator", transaction_admin: "Transaction Administrator",
  auction_admin: "Auction Administrator", support_admin: "Customer Support Administrator",
  finance_admin: "Finance Administrator", content_admin: "Content Administrator",
  executive_admin: "Executive Administrator", super_admin: "Super Administrator",
  admin: "Super Administrator",
};

export const isInternal = (user) => !!user && (INTERNAL_ROLES.includes(user.role) || user.role === "admin");
export const isSuperAdmin = (user) => !!user && SUPER_ADMIN_ROLES.includes(user.role);
export const isExternal = (user) => !!user && EXTERNAL_ROLES.includes(user.role);
export const canListCoach = (user) => !!user && LISTING_CAPABLE.includes(user.role);
export const roleLabel = (role) => ROLE_LABELS[role] || role;
